<template>
  <div class="xndetails">
    <!-- 资源简介 -->
    <div class="header_top">
      <div class="light"></div>
      <div v-if="detailsDate == null">
        <el-empty description="加载中..."></el-empty>
      </div>
      <div class="hdtop_content" v-else>
        <div class="hdcontent_left">
          <h1>{{ detailsDate.material.title }} <span v-if="detailsDate.material.bilingual == 1" class="zhen-icon"
              >中英双语</span
            ></h1>
          <div class="left_listbtn">
            <span>发布时间：{{ detailsDate.material.createTime }}</span>
            <span>文件大小：{{ detailsDate.material.fileSize | calSize }}</span>
            <span>发布人：{{ detailsDate.material.createName }}</span>
          </div>
          <!-- 所属类 -->
          <div class="ziy_class">
            <div
              class="type_list"
              v-for="(item, index) in detailsDate.types"
              :key="index"
            >
              <span>{{ item.typeBig }} :</span> <span>{{ item.typeSmalls }}</span>
            </div>
          </div>
          <!-- 介绍 -->
          <div class="zy_detailtxt">
            <p>{{ detailsDate.material.description }}</p>
          </div>
          <!-- 实验链接 -->
          <div class="shiy_link">
            <el-button class="shiy_btn" @click="zuopshiy">我要做实验</el-button>
          </div>
        </div>
        <!-- 实验简介视频 -->
        <div class="hdcontent_rig">
          <div class="tabs_rig">
            <el-radio-group v-model="tabPosition">
              <el-radio-button label="1">实验简介视频</el-radio-button>
              <el-radio-button style="margin-left: 5px" label="2"
                >教学引导视频</el-radio-button
              >
            </el-radio-group>
            <div class="vid_active" v-show="tabPosition == '1'">
              <div
                class="emnull"
                v-if="
                  detailsDate.material.introductionUrl == null ||
                  detailsDate.material.introductionUrl == '' ||
                  detailsDate.material.introductionUrl == undefined
                "
              >
                <el-empty :image-size="100" description="暂无资源"></el-empty>
              </div>
              <video
                v-else
                :src="formatUrl(detailsDate.material.introductionUrl)"
                controls
                controlsList="nodownload"
              ></video>
            </div>
            <div class="vid_active" v-show="tabPosition == '2'">
              <div
                class="emnull"
                v-if="
                  detailsDate.material.teachingUrl == null ||
                  detailsDate.material.teachingUrl == '' ||
                  detailsDate.material.teachingUrl == undefined
                "
              >
                <el-empty :image-size="100" description="暂无资源"></el-empty>
              </div>
              <video
                v-else
                :src="formatUrl(detailsDate.material.teachingUrl)"
                controls
                controlsList="nodownload"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 实验介绍 -->
    <div class="shiy_tab">
      <div class="shiy_center">
        <el-radio-group v-model="sytabactive">
          <el-radio-button label="1">实验介绍</el-radio-button>
          <el-radio-button style="margin-left: 10px" label="2">实验必读</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <!-- 资料内容 -->
    <div class="syzl_listall">
      <div v-if="detailsDate == null">
        <el-empty description="加载中..."></el-empty>
      </div>
      <div class="syzl_content" v-else>
        <div class="syzl_tabtxt" v-if="sytabactive == '1'">
          <el-tabs tab-position="top" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in readingone"
              :key="index"
              :label="item.name"
              :name="item.name"
            >
              <div class="editor—wrapper" v-html="item.content">
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="syzl_tabtxt" v-if="sytabactive == '2'">
         
          <el-tabs tab-position="top" v-model="activeNametwo" @tab-click="handleClicktwo">
            <el-tab-pane
              v-for="(item, index) in readingtwo "
              :key="index"
              :label="item.name"
              :name="item.name"
            >
          
              <div class="reading_txts" v-html="item.content">
               
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { calSize } from "@/utils";
export default {
  name: "xndetails",
  data() {
    return {
      tabPosition: "1", //视频切换
      sytabactive: "1", //介绍和必读切换
      activeName: "实验简介", //资料切换
      activeNametwo: "网络要求", //实验必读内容切换
      baseurl: this.$http.requrl,
    };
  },
  props: {
    detailsDate: {
      type: Object,
      default: true,
    },
    readingone:{
      type:Array,
      default: true,
    },
     readingtwo:{
      type:Array,
      default: true,
    },
  },
  filters: {
    calSize(fileSize) {
      return calSize(fileSize);
    }
  },
  mounted() {
 
  },
  methods: {
    formatUrl(url) {
      return url == null
        ? url
        : url.startsWith("/profile")
        ? this.baseurl + url
        : this.baseurl + "/profile/" + url;
    },
    // 上传的tabs列表
    handleClick(tab, event) {
      //   console.log(tab.name);
    },
    handleClicktwo(tab, event) {},
    zuopshiy() {
      let url;
      if(this.detailsDate.material.htmlUrl.indexOf('http') > -1 ||this.detailsDate.material.htmlUrl.indexOf('https') > -1 ){
         url =  this.detailsDate.material.htmlUrl;

      }else{
           url = this.baseurl + "/profile/" + this.detailsDate.material.htmlUrl;
      }
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.xndetails {
  width: 100%;
  overflow: hidden;
  // 头部简介
  .header_top {
    width: 100%;
    min-height: 380px;
    overflow: hidden;
    position: relative;
    background-color: #2f3a59;
    
    .light:after {
      content: "";
      display: block;
      position: absolute;
      width: 960px;
      height: 580px;
      top: -220px;
      left: -200px;
      background: rgba(116, 69, 103, 1);
      background: -moz-radial-gradient(
        center,
        ellipse cover,
        rgba(116, 69, 103, 1) 0%,
        rgba(116, 69, 103, 1) 22%,
        rgba(106, 65, 102, 1) 35%,
        rgba(86, 60, 93, 1) 46%,
        rgba(47, 58, 89, 1) 66%,
        rgba(47, 58, 89, 1) 100%
      );
      background: -webkit-gradient(
        radial,
        center center,
        0px,
        center center,
        100%,
        color-stop(0%, rgba(116, 69, 103, 1)),
        color-stop(22%, rgba(116, 69, 103, 1)),
        color-stop(35%, rgba(106, 65, 102, 1)),
        color-stop(46%, rgba(86, 60, 93, 1)),
        color-stop(66%, rgba(47, 58, 89, 1)),
        color-stop(100%, rgba(47, 58, 89, 1))
      );
      background: -webkit-radial-gradient(
        center,
        ellipse cover,
        rgba(116, 69, 103, 1) 0%,
        rgba(116, 69, 103, 1) 22%,
        rgba(106, 65, 102, 1) 35%,
        rgba(86, 60, 93, 1) 46%,
        rgba(47, 58, 89, 1) 66%,
        rgba(47, 58, 89, 1) 100%
      );
      background: -o-radial-gradient(
        center,
        ellipse cover,
        rgba(116, 69, 103, 1) 0%,
        rgba(116, 69, 103, 1) 22%,
        rgba(106, 65, 102, 1) 35%,
        rgba(86, 60, 93, 1) 46%,
        rgba(47, 58, 89, 1) 66%,
        rgba(47, 58, 89, 1) 100%
      );
      background: -ms-radial-gradient(
        center,
        ellipse cover,
        rgba(116, 69, 103, 1) 0%,
        rgba(116, 69, 103, 1) 22%,
        rgba(106, 65, 102, 1) 35%,
        rgba(86, 60, 93, 1) 46%,
        rgba(47, 58, 89, 1) 66%,
        rgba(47, 58, 89, 1) 100%
      );
      background: radial-gradient(
        ellipse at center,
        rgba(116, 69, 103, 1) 0%,
        rgba(116, 69, 103, 1) 22%,
        rgba(106, 65, 102, 1) 35%,
        rgba(86, 60, 93, 1) 46%,
        rgba(47, 58, 89, 1) 66%,
        rgba(47, 58, 89, 1) 100%
      );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#744567', endColorstr='#2f3a59', GradientType=1);
    }
    .light {
      position: absolute;
      width: 1200px;
      height: 100%;
      left: 50%;
      margin-left: -600px;
    }
    // 简介内容
    .hdtop_content {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      vertical-align: top;
      .hdcontent_left {
        width: 65%;
        float: left;
        h1 {
          font-weight: 400;
          font-size: 24px;
          letter-spacing: 1px;
          margin-top: 50px;
          line-height: 1.5;
          color: #fff;
            .zhen-icon {
            font-size: 12px;
            background: #50ddbb;
            padding: 0 5px 0 8px;
            margin-left: 10px;
            display: inline-block;
            vertical-align: middle;
            position: relative;
            height: 22px;
            line-height: 22px;
            color: #fff;
          }
          .zhen-icon:after {
            content: "";
            position: absolute;
            font-size: 0;
            height: 0;
            width: 0;
            border-top: 11px solid transparent;
            border-bottom: 11px solid transparent;
            border-left: 8px solid #50ddbb;
            top: 0;
            right: -8px;
          }
        }
        // 按钮操作
        .left_listbtn {
          margin: 10px 0;
          font-size: 14px;
          color: #fff;
          opacity: 0.5;
          margin-left: -20px;
          span {
            margin-left: 20px;
          }
        }
        // 所属专业类
        .ziy_class {
          display: flex;
          flex-wrap: wrap;
          .type_list {
            padding: 5px 30px 0 0;
            span {
              font-size: 14px;
              width: 100%;
              color: #fff;
              opacity: 0.5;
              margin-top: 15px;
              line-height: 20px;
            }
          }
        }
        // 介绍
        .zy_detailtxt {
          margin-top: 15px;
          font-size: 14px;
          line-height: 22px;
          min-height: 100px;
          p {
            color: #fff;
            margin: 0 0 10px;
          }
        }
        // 实验链接
        .shiy_link {
          margin-bottom: 20px;
          .shiy_btn {
            background-color: #50ddbb;
            color: #fff;
            border: none;
          }
        }
      }
      //   右侧视频
      .hdcontent_rig {
        width: 33%;
        float: right;
        padding-top: 50px;
        user-select: none;
        overflow: hidden;

        .tabs_rig {
          margin-left: 35px;
          //radio-button 切换
          ::v-deep .is-active {
            .el-radio-button__orig-radio:checked + .el-radio-button__inner {
              background-color: #50ddbb !important;
              border: none;
            }
          }
          ::v-deep .el-radio-button__inner {
            &:hover {
              color: #000;
            }
          }
          //   视频
          .vid_active {
            width: 360px;
            height: 240px;
            float: right;
            .emnull {
              width: 240px;
              height: 200px;
              text-align: center;
            }
            video {
              width: 100%;
              height: 100%;
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
  //   资料简介
  .shiy_tab {
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    margin-bottom: 20px;
    .shiy_center {
      width: 1200px;
      margin: 0 auto;
      user-select: none;
      // tab切换
      ::v-deep .is-active {
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background-color: #50ddbb !important;
          border: 1px solid #dcdfe6;
          box-shadow: none !important;
        }
      }
      ::v-deep .el-radio-button__inner {
        border: 1px solid #dcdfe6;
        &:hover {
          color: #000;
        }
      }
    }
  }
  //  资料内容
  .syzl_listall {
    width: 1200px;
    margin: 20px auto;
    min-height: 800px;
    background-color: #fff;
    .syzl_content {
      width: 100%;
      background-color: #fff;

      padding: 20px 30px;
      .syzl_tabtxt {
        .editor—wrapper,.reading_txts {
          pre {
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            white-space: pre-wrap;
            word-wrap: break-word;
          }
            ::v-deep  table {
        width: auto !important;
        max-width: 100% !important;
        margin: 0 auto;
        text-align: center;
        border-collapse: collapse;
        table-layout: fixed;
        border-radius: 5px;
        margin: 10px auto;
        border: 2px solid #e0e0e0;
        
        tbody {
          tr,
          td,th {
            border: 1px solid #e0e0e0;
            vertical-align: middle;
          }
          td,th {
            padding: 5px;
          }
        }
      }
        }
      }
    }
  }
}
</style>
